/**
 * ToggleBodyClass
 * ======================================
 * - toggle class on body
 * - multiple classes supported - "CLASSNAME CLASSNAME2 ..."
 * - add class to html attr [data-toggle="CLASSNAME"]
 * - remove class when attr [data-remove="CLASSNAME"]
 */

 const ELEMENTS = '.js-swap'
 const CLASSES = ['theme1', 'theme2', 'theme3', 'theme4']

 class Swap {
   constructor() {
     this.elements = document.querySelectorAll(ELEMENTS)

     if (!this.elements) {
       return false
     }

     this.elements.forEach(el => {
       el.addEventListener('click', this.toggle, false)
     })
   }

   toggle = (e) => {
     const randomClass = CLASSES[Math.floor(Math.random() * CLASSES.length)];

     if(document.body.classList.contains(randomClass)){
      this.toggle()

      return;
     }

     CLASSES.forEach(className => {
      document.body.classList.remove(className)
     })

     document.body.classList.toggle(randomClass)
   }
 }

 new Swap()
